import { createTypes } from "@/store/utils";

export const FETCH_TAGS_LIST = createTypes("FETCH_TAGS_LIST");
export const FETCH_FILTERED_TAGS_LIST = createTypes("FETCH_FILTERED_TAGS_LIST");
export const FETCH_FORM_TAGS_LIST = createTypes("FETCH_FORM_TAGS_LIST");
export const FETCH_TAGS_PER_PAGE_LIST = createTypes("FETCH_TAGS_PER_PAGE_LIST");
export const FETCH_TAG = createTypes("FETCH_TAG");
export const UPDATE_TAGS = "UPDATE_TAGS";
export const UPDATE_FILTERED_TAGS = "UPDATE_FILTERED_TAGS";
export const UPDATE_SELECTED_TAGS = "UPDATE_SELECTED_TAGS";
export const CREATE_TAG = createTypes("CREATE_TAG");
export const DELETE_TAG = createTypes("DELETE_TAG");
export const DELETE_TAGS = createTypes("DELETE_TAGS");
